import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { ProfilePanel } from "@/components/profile/profile-shell";
import { SupportPage, TicketsSection } from "@/pages/support";

// «Поддержка» в меню кабинета (кадр 4052:41704) — тот же FAQ, что и /support.
// «Мои обращения» в кадре нет: открываются ссылкой под FAQ (?view=tickets),
// крошки «Поддержка › Мои обращения» возвращают к вопросам.
export function ProfileSupportPage() {
  const $ = _c(6);
  const [params] = useSearchParams();
  let t0;
  if ($[0] !== params) {
    t0 = params.get("view");
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const view = t0;
  let t1;
  if ($[2] !== view) {
    t1 = [view];
    $[2] = view;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(_temp, t1);
  if (view === "tickets") {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ProfilePanel crumbs={[{
        label: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        to: "/profile/support"
      }, {
        label: "\u041C\u043E\u0438 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F"
      }]}><TicketsSection /></ProfilePanel>;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ProfilePanel title={"\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430"}><SupportPage embedded={true} /></ProfilePanel>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp() {
  window.scrollTo({
    top: 0
  });
}